var map = {
	"./404.svg": "sEM+",
	"./alarm.svg": "mMjV",
	"./appointment.svg": "+Npl",
	"./approval.svg": "Fsqj",
	"./bill.svg": "hOaM",
	"./bom.svg": "Y7KH",
	"./box.svg": "N5kO",
	"./bug.svg": "SVqS",
	"./chart.svg": "RjYk",
	"./clipboard.svg": "KO/S",
	"./compare.svg": "prnX",
	"./component.svg": "s2cW",
	"./config.svg": "e/UX",
	"./dashboard.svg": "BCGP",
	"./database.svg": "T380",
	"./documentation.svg": "zUKd",
	"./drag.svg": "vRhf",
	"./edit.svg": "ql+d",
	"./email.svg": "+4G4",
	"./example.svg": "OOLB",
	"./excel.svg": "OLl3",
	"./exception.svg": "aJhA",
	"./exit-fullscreen.svg": "G+/G",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./fence.svg": "WBhp",
	"./fg.svg": "Txwt",
	"./filter.svg": "ObMl",
	"./form.svg": "sTIr",
	"./fullscreen.svg": "WIff",
	"./guide 2.svg": "kA1i",
	"./guide.svg": "z74U",
	"./handle.svg": "cnev",
	"./home.svg": "U9Ws",
	"./icon.svg": "vUvT",
	"./intLog.svg": "prJH",
	"./international.svg": "SBEl",
	"./language.svg": "+Dip",
	"./link.svg": "KgwQ",
	"./list.svg": "vuHp",
	"./lock.svg": "FnAU",
	"./logout.svg": "KvOj",
	"./logs.svg": "49QO",
	"./md.svg": "Z0w5",
	"./message.svg": "G2zY",
	"./money.svg": "ig9B",
	"./nested.svg": "798r",
	"./order.svg": "gYtG",
	"./page.svg": "zrC5",
	"./pallet.svg": "HWYI",
	"./password.svg": "QjmH",
	"./paycheck.svg": "+Mec",
	"./pdf.svg": "M8Oc",
	"./people.svg": "GPe0",
	"./peoples.svg": "TgHK",
	"./plan.svg": "0Ex+",
	"./pm.svg": "jKg0",
	"./qc.svg": "K96Z",
	"./qq.svg": "R2jY",
	"./report.svg": "2nwU",
	"./returnPie.svg": "hCSM",
	"./returnSplit.svg": "arwQ",
	"./rework.svg": "iys2",
	"./rm.svg": "rLBm",
	"./road.svg": "qCRO",
	"./run.svg": "9Z5S",
	"./runMaintain.svg": "J1cM",
	"./search.svg": "Bx0U",
	"./service.svg": "nCjf",
	"./setting.svg": "Kttn",
	"./sfg.svg": "x/te",
	"./shopping.svg": "jRi0",
	"./sign.svg": "HE8u",
	"./size.svg": "Cr4N",
	"./star.svg": "60zo",
	"./summary.svg": "f3o5",
	"./tab.svg": "Jysk",
	"./table-setting.svg": "hTsv",
	"./table.svg": "oSYw",
	"./theme.svg": "hdtf",
	"./transfer.svg": "S35e",
	"./transport.svg": "EGRk",
	"./tree.svg": "3eCm",
	"./user.svg": "VdD3",
	"./warehouse.svg": "BupX",
	"./wechat.svg": "pYJ+",
	"./zip.svg": "0DNV"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 164